import React from 'react';
import { Form } from 'antd';
import type { FormInstance } from 'antd';
import { HtsFlagPriority } from '@evaltick/shared';
import { BEHAVIOR_CARDS } from '../htsQuestionWizardConfig';
import { SelectableOption } from '../SelectableOption';
import { StepHeader } from '../StepHeader';
import { HtsQuestionBehavior } from '../htsQuestionBehavior';
import type { HtsQuestionFormValues } from '../htsQuestionFormTypes';
import styles from '../HtsQuestionForm.module.scss';

interface BehaviorListProps {
  value?: HtsQuestionBehavior;
  onChange?: (value: HtsQuestionBehavior) => void;
  onSelectExtra: () => void;
}

const BehaviorList: React.FC<BehaviorListProps> = ({ value, onChange, onSelectExtra }) => (
  <div className={styles.behaviorList} role="radiogroup" aria-label="Question behavior">
    {BEHAVIOR_CARDS.map((card) => (
      <SelectableOption
        key={card.value}
        variant="card"
        selected={value === card.value}
        onClick={() => {
          onChange?.(card.value);
          onSelectExtra();
        }}
        className={styles.behaviorCard}
      >
        <div className={[styles.behaviorBadge, styles[`tint-${card.tint}`]].join(' ')}>{card.letter}</div>
        <div className={styles.behaviorCardBody}>
          <div className={styles.behaviorCardLabel}>
            {card.label} {card.sub && <span className={styles.behaviorCardSub}>{card.sub}</span>}
          </div>
          <div className={styles.behaviorCardHint}>{card.hint}</div>
        </div>
      </SelectableOption>
    ))}
  </div>
);

interface Step4BehaviorProps {
  form: FormInstance<HtsQuestionFormValues>;
}

export const Step4Behavior: React.FC<Step4BehaviorProps> = ({ form }) => {
  const resetDependentFields = () => {
    form.setFieldsValue({
      classificationTopic: null,
      readinessPillars: [],
      hardGateEquals: undefined,
      hardGatePriority: HtsFlagPriority.STANDARD,
      hardGateReason: undefined,
      hardGateGroupConditions: [],
    });
  };

  return (
    <div>
      <StepHeader
        stepNumber={4}
        title="What happens to the answer?"
        description="Choose exactly one — every question does exactly one of these five jobs."
      />
      <Form.Item name="behavior" rules={[{ required: true, message: 'Choose a behavior' }]}>
        <BehaviorList onSelectExtra={resetDependentFields} />
      </Form.Item>
    </div>
  );
};

export default Step4Behavior;
